import actions from '../actions/items';

const defaultState = {};

export default (state = defaultState, action) => {
    const add = () => {
        let items = {};
        action.payload.forEach(item => {
            items[item.itemId] = {
                ...(state[item.itemId] ? state[item.itemId] : {}),
                ...item
            };
        });
        return {
            ...state,
            ...items
        };
    };

    const wishlist = () => {
        const { payload } = action;
        return {
            ...state,
            [payload.itemId]: {
                ...state[payload.itemId],
                existsInWishList: payload.exists
            }
        };
    };

    const def = () => state;

    const reducers = {
        [actions.actionTypes.ADD]: add,
        [actions.actionTypes.WISHLIST]: wishlist
    };

    return !action || !action.type || !reducers[action.type]
        ? def()
        : reducers[action.type]();
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/reducers/items.js